/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lustrace_Outcome_ClearInputs */

const cs_lustrace_outcome_clear = /** @type {(inputs: Lustrace_Outcome_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čisto`)
};

const en_lustrace_outcome_clear = /** @type {(inputs: Lustrace_Outcome_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Lustrace_Outcome_ClearInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lustrace_outcome_clear = /** @type {((inputs?: Lustrace_Outcome_ClearInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lustrace_Outcome_ClearInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lustrace_outcome_clear(inputs)
	return cs_lustrace_outcome_clear(inputs)
});